import { type ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';
import HighlightCarousel from '~/components/HighlightCarousel';

import { MODULE_TYPES } from './index';

type CarouselProps = {
  items: ArticleCardType[];
  modulePosition: number;
};

type SlideContentProps = {
  item: ArticleCardType;
  modulePosition: number;
  position: number;
};

function SlideContent({ item, modulePosition, position }: SlideContentProps) {
  return (
    <ArticleCard
      className="block aspect-[4/5] size-full w-[80vw] md:h-[570px] md:w-[456px]"
      item={item}
      modulePosition={modulePosition}
      moduleType={MODULE_TYPES.carousel}
      name="LATEST_NEWS"
      pagePosition="Homepage Article Highlight Carousel"
      position={position}
      variant="4/5-text-over"
    />
  );
}

export default function ArticleHighlightCarousel({
  items,
  modulePosition
}: CarouselProps) {
  return (
    <div className="py-10 md:py-20">
      <HighlightCarousel
        slides={items}
        autoSlideDuration={3000}
        scaleDown={0.2}
        hasEqualGaps
        getSlideKey={(_, index) => `article-${index}`}
        renderSlideContent={(article, index) => (
          <SlideContent
            item={article}
            modulePosition={modulePosition}
            position={index + 1}
          />
        )}
      />
    </div>
  );
}
